import React from 'react';

const StyleThumbnail = ({ style, isSelected, onSelect }) => {
  return (
    <button
      onClick={onSelect}
      className={`
        relative w-full h-full rounded-sharper overflow-hidden
        transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98]
        ${isSelected
          ? 'ring-[3px] ring-[#0e734b] shadow-lg shadow-[#0e734b]/30'
          : 'ring-1 ring-[#D1DDD7] hover:ring-[#0e734b]/50'
        }
      `}
    >
      <div className="relative w-full h-full flex flex-col">
        {/* Image area */}
        <div className="relative flex-1 min-h-0">
          {style.previewImage ? (
            <img
              src={style.previewImage}
              alt={`${style.name} preview`}
              className="w-full h-full object-cover"
              loading="lazy"
              draggable="false"
            />
          ) : (
            <div className={`absolute inset-0 bg-gradient-to-br ${style.gradient || 'from-[#E4EFEA] to-[#0e734b]'}`} />
          )}

          {/* Subtle overlay */}
          <div className="absolute inset-0 bg-gradient-to-t from-white/80 via-transparent to-transparent" />

          {/* Scanline on selection */}
          {isSelected && <div className="forensic-scanline" />}
        </div>

        {/* Label */}
        <div className="absolute bottom-0 left-0 right-0 p-2 bg-white/95 border-t border-[#D1DDD7]">
          <h3 className="text-[10px] font-bold text-[#0e734b] uppercase tracking-[0.15em] leading-tight truncate">
            {style.name}
          </h3>
        </div>

        {/* Selection checkmark */}
        {isSelected && (
          <div className="absolute top-2 right-2 w-6 h-6 bg-[#0e734b] rounded-sharp flex items-center justify-center shadow-md">
            <span className="text-white text-xs font-bold">✓</span>
          </div>
        )}
      </div>
    </button>
  );
};

export default StyleThumbnail;
